export const BID_RESPONSE_ERRORS = {
    OUTBID: 'OUTBID',
    OUTBID_RESERVE_NOT_MET: 'OUTBID_RESERVE_NOT_MET',
    RESERVE_NOT_MET: 'RESERVE_NOT_MET',
    CLOSE_TO_RESERVE: 'CLOSE_TO_RESERVE',
    // bid not recorded errors
    AUCTION_CLOSED: 'AUCTION_CLOSED',
    SERVICE_ERROR: 'SERVICE_ERROR',
} as const;

export type BidErrorType = keyof typeof BID_RESPONSE_ERRORS;
